import * as React from 'react';
import { Col, Row } from 'react-grid-system';
import { BsPlusCircleFill } from 'react-icons/bs';
import { MdOutlineRemoveCircle, MdPostAdd } from 'react-icons/md';
import styled from 'styled-components';
import Card from './Card';


interface Props {
    productamount: any
    hanldeAddProduct: (data: any, amount: number) => void
}

export default function ModalAmount(props: Props) {

    const [amount, setAmount] = React.useState(1)
    
    const handleAddItem = () =>{}


    const handleIncrement = (type: any) => {
        if (type === 'incremenet') {
            let cremnt: any = amount
            setAmount(cremnt + 1)
        }
        if (type === 'decremenet') {
            if (amount === 0) {
                return
            }
            let cremnt: any = amount
            setAmount(cremnt - 1)
        }
    }


    return <Amount>
        <div className="content">
            <h3>Agregar a tu orden</h3>
            {
                props.productamount && (
                    <div className="header_amount">
                        <Card
                            data={props.productamount}
                            type={""}
                            handleAddItem={handleAddItem}
                            show_order={false}
                        />
                    </div>
                )
            }
            <div className="content_button">
                <Row align="center" justify="center">
                    <Col xs={4} className="text-center cold">
                        <button
                            onClick={() => handleIncrement('decremenet')}
                            className="btnclose"
                        >
                            <MdOutlineRemoveCircle />
                        </button>
                    </Col>
                    <Col xs={4} className="text-center">
                        <span>{amount}</span>
                    </Col>
                    <Col xs={4} className="text-center cold">
                        <button
                            onClick={() => handleIncrement('incremenet')}
                            className="btnclose"
                        >
                            <BsPlusCircleFill />
                        </button>
                    </Col>
                </Row>
            </div>
            <button className="btn btn-primary mt-3"
                onClick={() => props.hanldeAddProduct(props.productamount, amount)}
            >
                <MdPostAdd />  Agregar
            </button>
        </div>
    </Amount>
}


const Amount = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    width:100%; 
    height: 100vh;
    background: #0000003e;
    z-index: 3;
    padding: 1em;
    padding-bottom: 6em;
    display:flex;
    flex-direction: column;
    justify-content:flex-end;
    align-items:flex-end;
    .content{
        background:White;
        width: 100%;
        min-height: 10vh;
        padding: 1em;
        display:flex;
        flex-direction: column;
        justify-content:Center;
        align-items:Center;
        border-radius: 12px;
        span {
            font-size: 1.5em;
        }
        .header_amount{
            width:100%;
            text-align:center;
        }
        .content_button {
            margin-top: 1em;
            width: 70%;
            font-size: 1em;
            font-weight:bold;
        }
        button {
            width: 100%;
            font-weight:bold;
        }
    }
`